import { squareMetersToTsubo } from "@ippon/shared-utils";

export const resolveAreaTsubo = (
  unit?: {
    private_detail?: {
      area_tsubo?: number | string;
      area_sqm?: number | string;
    };
    common_detail?: {
      area_tsubo?: number | string;
      area_sqm?: number | string;
    };
  } | null,
  section?: {
    details?: Record<string, unknown>;
    rental_area_tsubo?: number | string;
  } | null,
): number => {
  const storedTsubo =
    unit?.private_detail?.area_tsubo ??
    unit?.common_detail?.area_tsubo ??
    section?.details?.area_tsubo ??
    section?.details?.rental_area_tsubo ??
    section?.rental_area_tsubo;

  const parsedTsubo = Number(storedTsubo);
  if (Number.isFinite(parsedTsubo) && parsedTsubo > 0) return parsedTsubo;

  const storedSquareMeters =
    unit?.private_detail?.area_sqm ??
    unit?.common_detail?.area_sqm ??
    section?.details?.area_sqm ??
    section?.details?.rental_area_m2;
  const parsedSquareMeters = Number(storedSquareMeters);
  return Number.isFinite(parsedSquareMeters) && parsedSquareMeters > 0
    ? squareMetersToTsubo(parsedSquareMeters)
    : 0;
};

export const resolveIsAncillaryUnit = (
  unitRevenueType?: string,
  legacyRevenueType?: string,
): boolean => {
  if (unitRevenueType === "stock_rent") return false;
  if (unitRevenueType === "stock_other") return true;
  return legacyRevenueType === "ancillary_income";
};
